import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, Router } from '@angular/router';
import { NEVER, Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { GlobalSettingsService } from '../services/ui/global-settings.service';
import { DigitalLogService } from '../services/sections/job/digital-log.service';
import { JobDigitalLogFormRequest } from '../models/digital-log/digital-log.model';

@Injectable({
	providedIn: 'root'
})
export class DigitalLogFormRequestsResolver implements Resolve<Observable<JobDigitalLogFormRequest[]>> {

	constructor(
		private router: Router,
		private digitalLogService: DigitalLogService
	) { }

	resolve(activatedRouteSnapshot: ActivatedRouteSnapshot) {
		GlobalSettingsService.isSecondaryLoaderLoading = true;
		return this.digitalLogService
			.getFormRequests(activatedRouteSnapshot.paramMap.get('token'))
			.pipe(
				catchError(() => {
					this.router.navigate(['/404']);
					GlobalSettingsService.isSecondaryLoaderLoading = false;
					return NEVER;
				})
			);
	}
}
